import { CustomCheckBoxField } from '../FormFields/GeneralFormFields';
import React from 'react';

const AutoPayCheckbox = ({
  checked,
  isAutoPayOptInEnabled,
  isAutoPayOptOutEnabled,
}: any) => {
  return (
    isAutoPayOptInEnabled && (
      <CustomCheckBoxField
        label="SignUp for autopay"
        name="autoPay"
        checked={checked}
        disabled={!isAutoPayOptOutEnabled}
      />
    )
  );
};

export default AutoPayCheckbox;
